import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-719a4276"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = {
  key: 0,
  class: "p-pl-2",
  style: {"padding-right":"1em"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home large-icon" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "legalEntityFields" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-col-5 p-sm-5" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-ml-6 p-mt-2" }, " * Campi obbligatori ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GvInputText = _resolveComponent("GvInputText")!
  const _component_GVAutocomplete = _resolveComponent("GVAutocomplete")!
  const _component_Card = _resolveComponent("Card")!
  const _component_GvSpinner = _resolveComponent("GvSpinner")!

  return (_openBlock(), _createBlock(_component_GvSpinner, { "is-loading": _ctx.isLoading }, {
    default: _withCtx(() => [
      _createVNode(_component_Card, null, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.props.showAvatar)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields || _ctx.props.fetchData,
                class: "inputfield",
                "field-name": "Ragione sociale *",
                id: "legalEntity",
                errors: _ctx.v$.name.$silentErrors,
                "is-dirty": _ctx.v$.name.$dirty,
                modelValue: _ctx.v$.name.$model,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GVAutocomplete, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "Indirizzo sede legale *",
                "is-dirty": _ctx.v$.legalAddress.$dirty,
                modelValue: _ctx.v$.legalAddress.$model,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.legalAddress.$model) = $event)),
                id: "legalAddress",
                onOnSelection: _ctx.onLegalAddressSelection,
                errors: _ctx.v$.legalAddress.$silentErrors
              }, null, 8, ["disabled", "is-dirty", "modelValue", "onOnSelection", "errors"]),
              _createVNode(_component_GvInputText, {
                disabled: true,
                class: "inputfield",
                "field-name": "Cittá *",
                id: "city",
                errors: _ctx.v$.city.$silentErrors,
                "is-dirty": _ctx.v$.city.$dirty,
                modelValue: _ctx.v$.city.$model,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.city.$model) = $event))
              }, null, 8, ["errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: true,
                class: "inputfield",
                "field-name": "CAP *",
                modelValue: _ctx.v$.zipCode.$model,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.zipCode.$model) = $event)),
                "is-dirty": _ctx.v$.zipCode.$dirty,
                id: "zipCode",
                errors: _ctx.v$.zipCode.$silentErrors
              }, null, 8, ["modelValue", "is-dirty", "errors"]),
              _createVNode(_component_GvInputText, {
                disabled: true,
                class: "inputfield",
                "field-name": "Provincia *",
                id: "prov",
                errors: _ctx.v$.prov.$silentErrors,
                "is-dirty": _ctx.v$.prov.$dirty,
                modelValue: _ctx.v$.prov.$model,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.prov.$model) = $event))
              }, null, 8, ["errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields || _ctx.props.fetchData,
                class: "inputfield",
                "field-name": "P. Iva *",
                id: "vat",
                errors: _ctx.v$.vat.$silentErrors,
                "is-dirty": _ctx.v$.vat.$dirty,
                modelValue: _ctx.v$.vat.$model,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.vat.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "Codice fiscale (se diverso da P.IVA) *",
                id: "ssn",
                errors: [],
                placeholder: _ctx.v$.vat.$model,
                modelValue: _ctx.state.ssn,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.ssn) = $event))
              }, null, 8, ["disabled", "placeholder", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "SDI *",
                id: "sdi",
                errors: _ctx.v$.sdi.$silentErrors,
                "is-dirty": _ctx.v$.sdi.$dirty,
                modelValue: _ctx.v$.sdi.$model,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.sdi.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "PEC *",
                id: "legalEmail",
                errors: _ctx.v$.legalEmail.$silentErrors,
                "is-dirty": _ctx.v$.legalEmail.$dirty,
                modelValue: _ctx.v$.legalEmail.$model,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.legalEmail.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields,
                class: "inputfield",
                "field-name": "Email amministrativa (se diverso da email di registrazione)",
                id: "administrativeEmail",
                errors: _ctx.v$.administrativeEmail.$silentErrors,
                "is-dirty": _ctx.v$.administrativeEmail.$dirty,
                modelValue: _ctx.v$.administrativeEmail.$model,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.v$.administrativeEmail.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _createVNode(_component_GvInputText, {
                disabled: _ctx.props.disableFields || _ctx.props.fetchData,
                class: "inputfield",
                "field-name": "Insegna *",
                id: "sign",
                errors: _ctx.v$.signName.$silentErrors,
                "is-dirty": _ctx.v$.signName.$dirty,
                modelValue: _ctx.v$.signName.$model,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.v$.signName.$model) = $event))
              }, null, 8, ["disabled", "errors", "is-dirty", "modelValue"]),
              _hoisted_6
            ])
          ])
        ]),
        _: 1
      }),
      _hoisted_7
    ]),
    _: 1
  }, 8, ["is-loading"]))
}